import IUser from './IUser';

export function transformUser(user: IUser): any {
    return {
        firstName: user.firstName,
        lastName: user.lastName,
    };
}
